export const ArbetsordernamnMaxLength = 50;
export const ArbetsorderAnteckningVirkesorderMaxLength = 20;
